// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgItemMoveLeft = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M8.5 16c-.3 0-.5-.1-.7-.3l-7-7c-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0s.4 1 0 1.4L2.9 8l6.3 6.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3"
    />
    <path
      fill={props.color ?? 'currentColor'}
      d="M15 16c-.3 0-.5-.1-.7-.3l-7-7c-.4-.4-.4-1 0-1.4l7-7c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.4 8l6.3 6.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3"
    />
  </svg>
)
export default SvgItemMoveLeft
